module.exports = __webpack_public_path__ + "img/annual.dfcab1f2.png";